import React from 'react';
import { Box, Image, Container, Heading, Text, VStack, SimpleGrid, HStack, Icon } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';

const MotionBox = motion(Box);

const AIMasteryProblem = ({ data }) => {
  return (
    <Box py={{ base: 16, md: 20 }} bg="white">
      <Container maxW="container.xl">
        <VStack spacing={12}>
          {/* Title */}
          <VStack spacing={4} textAlign="center">
            {/* 
            <Heading
              size="2xl"
              fontWeight="900"
              color="brand.800"
              maxW="4xl"
            >
              {data.title}
            </Heading>
            */}
            <Image src={data.title_image}  />

            {data.subtitle && (
              <Text fontSize="xl" color="brand.600" maxW="3xl">
                {data.subtitle}
              </Text>
            )}
          </VStack>

          {/* Two Column Comparison */}
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={8} w="full">
            {/* Current Reality */}
            {data.currentReality && (
              <MotionBox
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
              >
                <Box
                  p={8}
                  bg="red.50"
                  borderRadius="2xl"
                  borderLeft="6px solid"
                  borderColor="red.500"
                  h="full"
                >
                  <VStack align="stretch" spacing={4}>
                    <Text
                      fontSize="xl"
                      fontWeight="700"
                      color="brand.800"
                    >
                      {data.currentReality.title}
                    </Text>
                    {data.currentReality.points?.map((item, index) => (
                      <HStack key={index} align="flex-start" spacing={3}>
                        <Icon
                          as={FaTimesCircle}
                          boxSize={5}
                          color="red.500"
                          mt={1}
                          flexShrink={0}
                        />
                        <Text color="brand.600" fontSize="md">
                          {item}
                        </Text>
                      </HStack>
                    ))}
                  </VStack>
                </Box>
              </MotionBox>
            )}

            {/* Actual Job Requirements */}
            {data.actualJob && (
              <MotionBox
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.2 }}
              >
                <Box
                  p={8}
                  bg="green.50"
                  borderRadius="2xl"
                  borderLeft="6px solid"
                  borderColor="accent.green"
                  h="full"
                >
                  <VStack align="stretch" spacing={4}>
                    <Text
                      fontSize="xl"
                      fontWeight="700"
                      color="brand.800"
                    >
                      {data.actualJob.title}
                    </Text>
                    {data.actualJob.points?.map((item, index) => (
                      <HStack key={index} align="flex-start" spacing={3}>
                        <Icon
                          as={FaCheckCircle}
                          boxSize={5}
                          color="accent.green"
                          mt={1}
                          flexShrink={0}
                        />
                        <Text color="brand.600" fontSize="md">
                          {item}
                        </Text>
                      </HStack>
                    ))}
                  </VStack>
                </Box>
              </MotionBox>
            )}

            {/* Fallback to old structure if new structure not available */}
            {!data.currentReality && data.everyoneKnows && (
              <MotionBox
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
              >
                <Box
                  p={8}
                  bg="green.50"
                  borderRadius="2xl"
                  borderLeft="6px solid"
                  borderColor="accent.green"
                  h="full"
                >
                  <VStack align="stretch" spacing={4}>
                    <Text fontSize="xl" fontWeight="700" color="brand.800">
                      What everyone's talking about:
                    </Text>
                    {data.everyoneKnows?.map((item, index) => (
                      <HStack key={index} align="flex-start" spacing={3}>
                        <Icon as={FaCheckCircle} boxSize={5} color="accent.green" mt={1} flexShrink={0} />
                        <Text color="brand.600" fontSize="md">{item}</Text>
                      </HStack>
                    ))}
                  </VStack>
                </Box>
              </MotionBox>
            )}

            {!data.actualJob && data.nobodyTeaches && (
              <MotionBox
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.2 }}
              >
                <Box
                  p={8}
                  bg="red.50"
                  borderRadius="2xl"
                  borderLeft="6px solid"
                  borderColor="red.500"
                  h="full"
                >
                  <VStack align="stretch" spacing={4}>
                    <Text fontSize="xl" fontWeight="700" color="brand.800">
                      What nobody's teaching systematically:
                    </Text>
                    {data.nobodyTeaches?.map((item, index) => (
                      <HStack key={index} align="flex-start" spacing={3}>
                        <Icon as={FaTimesCircle} boxSize={5} color="red.500" mt={1} flexShrink={0} />
                        <Text color="brand.600" fontSize="md">{item}</Text>
                      </HStack>
                    ))}
                  </VStack>
                </Box>
              </MotionBox>
            )}
          </SimpleGrid>

          {/* Tagline */}

          {/* Visual Placeholder */}
          {data.visualPlaceholder && (
            <Box
              p={0}
              bg="gray.100"
              borderRadius="xl"
              borderStyle="dashed"
              borderWidth="2px"
              borderColor="gray.300"
              textAlign="center"
            >
              <Image src="/images/aidabbler.jpeg"  />
            </Box>
          )}
          {data.tagline && (
            <MotionBox
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              <Text
                fontSize={{ base: '2xl', md: '3xl' }}
                fontWeight="900"
                color="purple.600"
                textAlign="center"
              >
                {data.tagline}
              </Text>
            </MotionBox>
          )}
        </VStack>
      </Container>
    </Box>
  );
};

export default AIMasteryProblem;
